import utils from '@/libs/utils/comm.js';
import Ipc from "@/libs/utils/Ipc";

class ChargeUtils {
    type = "";//计费类型
    data = {};//计费数据
    time = 0;//产生时间
    start = 0;//开始时间
    capping = 0;//封顶
    openTime = 0;//开后多少分钟
    openMoney = 0;//开台多少分钟内费用
    /**
     * 注册数据
     * @param type
     * @param data
     */
    constructor(type, data) {
        this.type = type;
        this.data = data;
        return this;
    }

    /**
     * 设置封顶 0 无封顶
     */
    setCapping(v) {
        this.capping = v;
        return this;
    }

    /**
     * 开后多少分钟
     * @param v
     */
    setOpenTime(v) {
        this.openTime = v;
        return this;
    }

    /**
     * 开启多少金额
     * @param v
     */
    setOpenMoney(v) {
        this.openMoney = v;
        return this;
    }

    /**
     * 开始时间
     * @param _time
     */
    setStart(_time) {
        if (_time == "") {
            return this;
        }
        let timeAr = _time.split(':');
        if (timeAr.length <= 0) {
            return this;
        }
        this.start = timeAr.length > 0 ? (timeAr[0] * 60) : 0 + timeAr.length > 1 ? timeAr[1] : 0;
        return this;
    }

    /**
     * 中间时间
     * @param _time
     * @returns {ChargeUtils}
     */
    setTime(_time) {
        this.time = _time;
        return this;
    }

    /**
     * 获取类型【】
     * @returns {string}
     */
    getTypeName() {
        if (this.type == 'hour') {
            return "小时计费";
        }

        if (this.type == 'packet') {
            return "包段计费";
        }

        if (this.type == 'segment') {
            return "包场计费";
        }

        if (this.type == 'timeshar') {
            return "分时段计费";
        }
    }

    /**
     * 开单优惠
     */
    getCheapMoney() {
        if (this.time <= this.openTime) {
            return this.openMoney;
        }
        return 0;
    }

    /**
     * 计费标准费用
     */
    getCalMoney() {
        let hour = 0;
        let minutes = 0;
        hour = parseInt(this.time / 60);
        minutes = this.time % 60;
        let dataAr = this.data;
        if (this.type == 'hour') {
            if (this.time > this.openTime && hour == 0) hour = 1;
            return parseFloat(dataAr.money) * hour;
        }

        if (this.type == 'packet') {
            if (this.time <= 0) return 0;
            //未超过dataAr.time小时
            if (hour < dataAr.time && this.time > this.openTime) {
                return dataAr.money;
            }
            let count = parseInt(hour / dataAr.time);
            return dataAr.money * count;
        }

        if (this.type == 'segment') {
            if (this.time <= 0) return 0;
            let openHour = parseInt((this.start + this.time) / 60);
            //超过多少分钟加收下一场包场费用；
            let vAr = [];//计费数组
            if (dataAr.state == 1) {
                let isvAr = false;//是否进入计费模块-跳出计费模块
                for (var i = 0; i <= hour; i++) {
                    let nowHour = ((this.start + i * 60) / 60) % 24;
                    for (var j in dataAr.data) {
                        let data = dataAr.data[j];
                        let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                        let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                        if (this.getHourRegion(start, end).indexOf(nowHour) >= 0 && !isvAr) {
                            vAr.push(data);
                            isvAr = true;
                        }
                        if (nowHour == end && isvAr) {
                            isvAr = false;
                        }
                    }
                }
                //判断多少免费
                if (vAr.length > 0 && dataAr.state == 1) {
                    let data = vAr[vAr.length - 1];
                    let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                    if (openHour == start && minutes <= dataAr.state_1_time) {
                        vAr.splice(vAr.length - 1, 1);
                    }
                }
            }
            if (dataAr.state == 2 || dataAr.state == 3) {
                let isvAr = false;//是否进入计费模块-跳出计费模块
                for (var i = 0; i <= hour; i++) {
                    let nowHour = ((this.start + i * 60) / 60) % 24;
                    for (var j in dataAr.data) {
                        let data = dataAr.data[j];
                        let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                        let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                        if (this.getHourRegion(start, end).indexOf(nowHour) >= 0 && !isvAr) {
                            vAr.push(data);
                            break;
                        }
                    }
                    if (vAr.length > 0) break;
                }
            }
            console.log(vAr);
            let money = 0;
            for (var i in vAr) {
                money += vAr[i].money;
            }
            return money;
        }

        if (this.type == 'timeshar') {
            if (this.time <= 0) return 0;
            let isvAr = false;//是否进入计费模块-跳出计费模块
            let money = 0;
            //按小时计费
            if (dataAr.state == 1) {
                if(hour <= 0) hour = 1;
                for (var i = 0; i < hour; i++) {
                    let nowHour = ((this.start + i * 60) / 60) % 24;
                    for (var j in dataAr.state1Data.data) {
                        let data = dataAr.state1Data.data[j];
                        let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                        let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                        if (this.getHourRegion(start, end).indexOf(nowHour) >= 0) {
                            money += data['money'];
                            if (!isvAr) isvAr = true;
                        }
                        if (nowHour == end && isvAr) {
                            isvAr = false;
                        }
                    }
                }
            }
            //按小时包段
            if (dataAr.state == 2) {
                //判断是否时间未超过
                if (this.time <= dataAr.state2Data.g_free_time * 60) {
                    money = parseInt(this.time / 60) * dataAr.state2Data.g_free_money +
                        (this.time % 60 > 0 ? dataAr.state2Data.g_free_money : 0);
                } else {
                    for (var j in dataAr.state2Data.data) {
                        let data = dataAr.state2Data.data[j];
                        let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                        let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                        let hourFor = parseInt(this.time / (data.time * 60)) + (this.time % (data.time * 60) > 0 ? 1 : 0);
                        if (hourFor <= 0) hourFor = 1;//少于1次就算1次
                        let isvAr = false;
                        for (var i = 0; i < hourFor; i++) {
                            let nowHour = parseInt(((this.start + i * data.time * 60) / 60) % 24);
                            if (this.getHourRegion(start, end).indexOf(nowHour) >= 0) {
                                money += data.money;
                                if (!isvAr) {
                                    isvAr = true;
                                }
                            }
                        }
                    }
                }
            }
            //按分钟包段计算
            if (dataAr.state == 3) {
                for (var j in dataAr.state3Data.data) {
                    let data = dataAr.state3Data.data[j];
                    let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                    let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                    let minuteFor = parseInt(this.time / data.time);
                    let isvAr = false;
                    minuteFor = minuteFor <= 0 ? 1 : minuteFor;
                    for (var i = 0; i < minuteFor; i++) {
                        let nowHour = parseInt(((this.start + i * data.time) / 60) % 24);
                        if (this.getHourRegion(start, end).indexOf(nowHour) >= 0) {
                            money += data.money;
                            if (!isvAr) {
                                isvAr = true;
                            }
                        }
                    }
                }
            }
            return money;
        }

    }

    /**
     * 超出时段
     */
    getExceedMoney() {
        let dataAr = this.data;
        if (this.type == 'hour') {
            if (this.time < 60 || this.time <= 0) return 0;
            let minutes = this.time % 60;
            let minuteMoney = (parseFloat(dataAr.money) / 60);
            if (dataAr.state == 1) {
                return utils.returnFloat(minuteMoney * minutes);
            }
            if (dataAr.state == 2) {
                if (minutes <= dataAr.free_time) {
                    return 0;
                }
                if (minutes > dataAr.free_time && minutes <= dataAr.no_free_time) {
                    return minuteMoney * dataAr.no_free_time;
                }

                if (minutes > dataAr.no_free_time) {
                    return parseFloat(dataAr.money);
                }
            }
        }

        if (this.type == 'packet') {
            if (this.time < dataAr.time * 60 || this.time <= 0) return 0;
            let count = parseInt(this.time / (dataAr.time * 60));
            let minutes = this.time % (dataAr.time * 60);
            if (count <= 0) return 0;
            //按实际分数来算
            if (dataAr.state == 1) {
                let minuteMoney = utils.returnFloat(dataAr.money / (60 * dataAr.time));
                return utils.returnFloat(minuteMoney * minutes);
            }
            //按每多少分钟多少钱
            if (dataAr.state == 2) {
                let minuCount = parseInt(minutes / dataAr.cal_time) + (minutes % dataAr.cal_time > 0 ? 1 : 0);
                return utils.returnFloat(dataAr.cal_money * minuCount);
            }
            //安每小时多少钱，区间操作
            if (dataAr.state == 3) {
                let childHour = parseInt(minutes / 60);
                let childMinutes = minutes % 60;
                let hourMoney = childHour * dataAr.cal_hour_money;
                let fenMoney = 0;
                if (childMinutes > 0) {
                    if (childMinutes > dataAr.free_time) {
                        if (childMinutes <= dataAr.no_free_time) {
                            fenMoney = (dataAr.cal_hour_money / 60) * dataAr.no_free_time;
                        }

                        if (childMinutes > dataAr.no_free_time) {
                            fenMoney = dataAr.cal_hour_money;
                        }
                    }
                }
                return parseFloat(fenMoney) + parseFloat(hourMoney);
            }

            return 0;
        }

        if (this.type == 'segment') {
            if (dataAr.state == 2 || dataAr.state == 3) {
                let hour = parseInt(this.time / 60);
                let minutes = this.time % 60;
                let vAr = [];
                let isvAr = false;
                let lastHour = 0;
                for (var i = 0; i <= hour; i++) {
                    let nowHour = ((this.start + i * 60) / 60) % 24;
                    for (var j in dataAr.data) {
                        let data = dataAr.data[j];
                        let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                        let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                        if (this.getHourRegion(start, end).indexOf(nowHour) >= 0 && !isvAr) {
                            vAr.push(data);
                            isvAr = true;
                        }
                        if (nowHour == end && isvAr) {
                            lastHour = i;
                            break;
                        }
                    }
                }
                console.log(lastHour);
                if (dataAr.state == 2) {
                    let nMiuntes = (hour - lastHour) * 60 + minutes;
                    return utils.returnFloat(nMiuntes * (dataAr['state_2_money'] / 60));
                }
                //安每小时多少钱，区间操作
                if (dataAr.state == 3) {
                    let nMiuntes = (hour - lastHour) * 60 + minutes;
                    let childHour = parseInt(nMiuntes / 60);
                    let childMinutes = nMiuntes % 60;
                    let hourMoney = childHour * dataAr.state_3_money;
                    let fenMoney = 0;
                    if (childMinutes > 0) {
                        if (childMinutes > dataAr.state_3_free_time) {
                            if (childMinutes <= dataAr.state_3_no_free_time) {
                                fenMoney = (dataAr.state_3_money / 60) * dataAr.state_3_no_free_time;
                            }

                            if (childMinutes > dataAr.state_3_cal_free_time) {
                                fenMoney = dataAr.state_3_money;
                            }
                        }
                    }
                    return parseFloat(fenMoney) + parseFloat(hourMoney);
                }
            }
        }

        if (this.type == 'timeshar') {

            if (dataAr.state == 1) {
                let minutes = this.time % 60;
                let hour = parseInt(this.time / 60);
                let isvAr = false;
                let vAr = [];
                if (dataAr.state == 1) {
                    for (var i = 0; i < hour; i++) {
                        let nowHour = ((this.start + i * 60) / 60) % 24;
                        for (var j in dataAr.state1Data.data) {
                            let data = dataAr.state1Data.data[j];
                            let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                            let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                            if (this.getHourRegion(start, end).indexOf(nowHour) >= 0 && !isvAr) {
                                vAr.push(data);
                                isvAr = true;
                            }
                            if (nowHour == end && isvAr) {
                                isvAr = false;
                            }
                        }
                    }
                    //按分钟数来计算
                    if (dataAr.state1Data.type == 1 && vAr.length > 0) {
                        let data = vAr[vAr.length - 1];
                        let minuteMoney = utils.returnFloat(data.money / 60);
                        return utils.returnFloat(minuteMoney * minutes);
                    }
                    //按区间
                    if (dataAr.state1Data.type == 2 && vAr.length > 0) {
                        let data = vAr[vAr.length - 1];
                        let stateData = dataAr.state1Data;
                        return this.getAreaMoney(minutes, {
                            money: data.money,
                            free_time: stateData.free_time,
                            no_free_time: stateData.no_free_time,
                            cal_free_time: stateData.cal_free_time
                        });
                    }
                }
            }
            //按小时包段
            if (dataAr.state == 2) {
                //判断是否时间未超过
                if (this.time <= dataAr.state2Data.g_free_time * 60) {
                    return 0;
                }
                let vData = null;
                for (var j in dataAr.state2Data.data) {
                    let data = dataAr.state2Data.data[j];
                    let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                    let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                    let hourFor = parseInt(this.time / (data.time * 60)) + (this.time > (data.time * 60) ? 1 : 0);
                    let isvAr = false;
                    for (var i = 0; i < hourFor; i++) {
                        let nowHour = parseInt(((this.start + i * data.time * 60) / 60) % 24);
                        if (this.getHourRegion(start, end).indexOf(nowHour) >= 0) {
                            if (!isvAr) {
                                isvAr = true;
                            }
                        }
                        if (nowHour == end && isvAr) {
                            vData = data;
                            isvAr = false;
                        }
                    }
                }
                //最后数据
                if (vData != null) {
                    let minuteMoney = utils.returnFloat(vData.money / (60 * vData.time));
                    let mins = parseInt(this.time % (vData.time * 60));
                    if (mins <= 0) return 0;
                    if (dataAr.state2Data.type == 1) {
                        return utils.returnFloat(minuteMoney * mins);
                    }

                    if (dataAr.state2Data.type == 2) {
                        let fenMoney = utils.returnFloat(vData.money /vData.time);
                        return this.getAreaMoney(mins, {
                            money: fenMoney,
                            free_time: dataAr.state2Data.free_time,
                            no_free_time: dataAr.state2Data.no_free_time,
                            cal_free_time: dataAr.state2Data.cal_free_time
                        });
                    }
                }
            }
            //按分钟包段计算
            if (dataAr.state == 3) {
                let vData = null;
                let hour = parseInt(this.time / 60) + (this.time % 60 > 0 ? 1 : 0);
                let isvAr = false;
                for (var i = 0; i < hour; i++) {
                    let nowHour = ((this.start + i * 60) / 60) % 24;
                    for (var j in dataAr.state3Data.data) {
                        let data = dataAr.state3Data.data[j];
                        let start = data.star_time > 23 ? (data.star_time - 24) : data.star_time;
                        let end = data.end_time > 23 ? (data.end_time - 24) : data.end_time;
                        if (this.getHourRegion(start, end).indexOf(nowHour) >= 0 && !isvAr) {
                            vData = data;
                            isvAr = true;
                        }
                        if (nowHour == end && isvAr) {
                            isvAr = false;
                        }
                    }
                }
                if (vData != null) {
                    let mins = this.time % vData.time;
                    if (mins <= 0) return 0;
                    if (mins <= dataAr.state3Data.free_money) {
                        return utils.returnFloat(vData.money * dataAr.state3Data.free_time);
                    } else {
                        return utils.returnFloat((vData.money / vData.time) * mins);
                    }
                }
            }
        }
        return 0;
    }

    /**
     * 全部金额
     */
    getAllMoney() {
        let money = parseFloat(this.getCheapMoney()) + parseFloat(this.getCalMoney()) + parseFloat(this.getExceedMoney());
        if (this.capping > 0 && this.capping < money) money = this.capping;
        console.log(this.capping + "|" + money);
        return money;
    }

    /**
     * 获取记事方式文本信息
     */
    getCalText() {
        //
        if (this.type == 'hour') {
            return this.getCalHourText();
        }

        if (this.type == 'packet') {
            return this.getCalPacketText();
        }

        if (this.type == 'segment') {
            return this.getCalSegmentText();
        }

        if (this.type == 'timeshar') {
            return this.getCalTimesharText();
        }
    }

    /**
     * 超出时段计算
     */
    getExceedText() {
        if (this.type == 'hour') {
            return this.getExceedHourText();
        }

        if (this.type == 'packet') {
            return this.getExceedPacketText();
        }

        if (this.type == 'segment') {
            return this.getExceedSegmentText();
        }

        if (this.type == 'timeshar') {
            return this.getExceedTimesharText();
        }
    }

    /**
     * 按小时[计费方式]
     */
    getCalHourText() {
        let dataAr = this.data;
        return "按小时计费，每小时" + utils.returnFloat(dataAr.money) + "元";
    }

    /**
     * 按包段计费
     */
    getCalPacketText() {
        let dataAr = this.data;
        return "按包段计费，每" + dataAr.time + "小时" + utils.returnFloat(dataAr.money) + "元";
    }

    /**
     * 按包场计费
     */
    getCalSegmentText() {
        let dataAr = this.data;
        let text = "按包场计算，";
        for (var i in dataAr.data) {
            text += dataAr.data[i].star_time > 23 ? ('次日' + (dataAr.data[i].star_time - 24) + '点') : (dataAr.data[i].star_time + '点');
            text += "到" + (dataAr.data[i].end_time > 23 ? ('次日' + (dataAr.data[i].end_time - 24) + '点') : (dataAr.data[i].end_time + '点'));
            text += dataAr.data[i].money + "元；";
        }
        return text;
    }

    /**
     * 按分时间计算
     */
    getCalTimesharText() {
        let dataAr = this.data;
        let text = "";
        if (dataAr.state == 1) {
            text = "分时段(小时)计费，";
            for (var i in dataAr.state1Data.data) {
                text += dataAr.state1Data.data[i].star_time + "点到" + dataAr.state1Data.data[i].end_time + "点，每小时" + dataAr.state1Data.data[i].money + "元；";
            }
        }

        if (dataAr.state == 2) {
            text = "分时段(包段)计费，";
            for (var i in dataAr.state2Data.data) {
                text += dataAr.state2Data.data[i].star_time + "点到" + dataAr.state2Data.data[i].end_time + "点，每" + dataAr.state2Data.data[i].time + "小时" + dataAr.state2Data.data[i].money + "元；";
            }
        }

        if (dataAr.state == 3) {
            text = "分时段(包段)计费，";
            for (var i in dataAr.state3Data.data) {
                text += dataAr.state3Data.data[i].star_time + "点到" + dataAr.state3Data.data[i].end_time + "点，每" + dataAr.state3Data.data[i].time + "分钟" + dataAr.state3Data.data[i].money + "元；";
            }
        }
        return text;
    }


    /**
     * 按小时[超出时段]
     */
    getExceedHourText() {
        let dataAr = this.data;
        if (dataAr.state == 1) {
            return "超出1小时，按每分钟数" + utils.returnFloat(dataAr.money / 60) + "元来计费。";
        }
        if (dataAr.state == 2) {
            return "超出1小时，" + dataAr.free_time + "分钟内免费，大于" + dataAr.free_time + "到" + dataAr.no_free_time + "分钟；" +
                "按" + dataAr.no_free_time + "分钟计算，超过" + dataAr.no_free_time + "分钟后按1小时候计算。";
        }
    }

    /**
     * 按包段计费[超出时段]
     */
    getExceedPacketText() {
        let dataAr = this.data;
        if (dataAr.state == 1) {
            return "消费超出一个时段，按每分钟数" + utils.returnFloat(dataAr.money / (60 * dataAr.time)) + "元来计费。";
        }

        if (dataAr.state == 2) {
            return "消费超出" + dataAr.time + "小时，按每" + dataAr.cal_time + "分钟" + utils.returnFloat(dataAr.cal_money) + "元。";
        }

        if (dataAr.state == 3) {
            return "超出" + dataAr.time + "小时，按每小时" + dataAr.cal_hour_money + "元计费，" +
                "超出的分钟数按区间计费。" + dataAr.free_time + "分钟内免费； " +
                " 超过" + dataAr.free_time + "至" + dataAr.no_free_time + "分钟，按" + dataAr.cal_free_time + "分钟计费；超过" + dataAr.cal_free_time + "分钟，按1小时计算；";
        }

    }

    getExceedSegmentText() {
        let dataAr = this.data;
        if (dataAr.state == 1) {
            return dataAr['state_1_time'] + "分钟之内免费；  超过" + dataAr['state_1_time'] + "分钟加收下一场包场费用；";
        }

        if (dataAr.state == 2) {
            return "消费超出1个场次，按实际分钟数计费。每小时" + dataAr['state_2_money'] + "元";
        }

        if (dataAr.state == 3) {
            return "消费超出1个场次，按每小时" + dataAr.state_3_money + "元计费，" +
                "超出的分钟数按区间计费。" + dataAr.state_3_free_time + "分钟内免费； " +
                " 超过" + dataAr.state_3_free_time + "至" + dataAr.state_3_no_free_time + "分钟，按" + dataAr.state_3_no_free_time + "分钟计费；超过" + dataAr.state_3_cal_free_time + "分钟，按1小时计算；";
        }
    }

    getExceedTimesharText() {
        let dataAr = this.data;
        if (dataAr.state == 1) {
            if (dataAr.state1Data.type == 1) {
                return "消费超出时段，按实际分钟数计费。";
            }

            if (dataAr.state1Data.type == 2) {
                return "消费超出1小时，超出的分钟数按区间计费。" + dataAr.state1Data.free_time + "分钟内免费； " +
                    " 超过" + dataAr.state1Data.free_time + "至" + dataAr.state1Data.no_free_time + "分钟，按" + dataAr.state1Data.no_free_time + "分钟计费；超过" + dataAr.state1Data.cal_free_time + "分钟，按1小时计算；";
            }
        }

        if (dataAr.state == 2) {

            if (dataAr.state2Data.type == 1) {
                return "消费超出1个包段，超出的分钟数按区间计费。" + dataAr.state2Data.free_time + "分钟内免费； " +
                    " 超过" + dataAr.state2Data.free_time + "至" + dataAr.state2Data.no_free_time + "分钟，按" + dataAr.state2Data.no_free_time + "分钟计费；超过" + dataAr.state2Data.cal_free_time + "分钟，按1小时计算；";
            }

            if (dataAr.state2Data.type == 2) {
                return "消费超出1小时，超出的分钟数按区间计费。" + dataAr.state1Data.free_time + "分钟内免费； " +
                    " 超过" + dataAr.state1Data.free_time + "至" + dataAr.state1Data.no_free_time + "分钟，按" + dataAr.state1Data.no_free_time + "分钟计费；超过" + dataAr.state1Data.cal_free_time + "分钟，按1小时计算；";
            }
        }

        if (dataAr.state == 3) {
            return "超出分钟数" + dataAr.state3Data.free_time + "分钟内；超过后按" + dataAr.state3Data.free_money + "分钟来计算。";
        }
    }


    /**
     * 获取2个小时想差数组
     * @param s 开始时间
     * @param e 结束时间
     * @param bool 是否24小时制
     */
    getHourAr(s, e, bool = false) {
        let size = e - s;
        let hAr = [];
        for (var i = 0; i < size; i++) {
            let value = s + i;
            if (bool) {
                value = value >= 24 ? (value - 24) : value;
            }
            hAr.push(value);
        }
        return hAr;
    }

    /**
     * 获取区间金额
     * @param minutes 分钟
     * @param data {money:1小时金额,free_time:分钟之内免费,no_free_time:大于多少分钟到多少,cal_free_time:}
     * @returns {number}
     */
    getAreaMoney(minutes, data) {
        let childHour = parseInt(minutes / 60);
        let childMinutes = minutes % 60;
        let hourMoney = childHour * data.money;
        let fenMoney = 0;
        if (childMinutes > 0) {
            if (childMinutes > data.free_time) {
                if (childMinutes <= data.no_free_time) {
                    fenMoney = (data.money / 60) * data.cal_free_time;
                }
                if (childMinutes > data.no_free_time) {
                    fenMoney = data.money;
                }
            }
        }
        return parseFloat(fenMoney) + parseFloat(hourMoney);
    }

    /**
     * 获取时间差
     * 获取时间差
     * @param s
     * @param e
     */
    getHourRegion(s, e) {
        let xtue = true;
        let reAr = [];
        let i = 0;
        while (xtue) {
            let v = (s + i) >= 24 ? (s + i - 24) : (s + i);
            if (e > s) {
                if (v >= s && v < e) reAr.push(v); else xtue = false;
            } else {
                if (v >= s || v < e) reAr.push(v); else xtue = false;
            }
            if (i >= 23) xtue = false;
            i++;
        }
        return reAr;
    }

}

function getInit(type, data) {
    return new ChargeUtils(type, data);
}

export default ChargeUtils;
